import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=0ad937f5&scoped=true&"
import script from "./ChangePassword.js?vue&type=script&lang=js&"
export * from "./ChangePassword.js?vue&type=script&lang=js&"
import style0 from "./../Login/Login.scss?vue&type=style&index=0&id=0ad937f5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad937f5",
  null
  
)

export default component.exports